import React from "react";
import "./../component_styles/VaccinationSection.css";
import { useNavigate } from "react-router-dom";

const VaccinationSection = () => {
  const navigate = useNavigate();
  return (
    <div className="vaccination-section bg-white  ">
      <div className="vaccination-info">
        <div className="text-content">
          <h2>Vaccinations Available</h2>
          <p>
            Our pharmacists provide a wide range of vaccinations, including flu
            shots, COVID-19 boosters, and routine immunizations. We also offer
            all travel vaccines.
          </p>
          <button className="book-btn" onClick={() => navigate("/vaccination")}>
            Request a Vaccination
          </button>
        </div>
        <img
          src="/assets/Pharmacist-vaccination.png"
          alt="Vaccination"
          className="section-image"
        />
      </div>

      <div className="travel-clinic">
        <div className="text-content">
          <h2>Travel Clinic</h2>
          <p>
            Traveling soon? Check out our virtual travel clinic partner. Get
            your prescriptions and vaccinations for your trip on the fly. Ensure
            your trip is safe and worry-free. Click here for QR code.
          </p>
          <button
            className="book-btn"
            onClick={() =>
              window.open("https://www.virtualtravelclinic.ca", "_blank")
            }
          >
            Visit Travel Clinic
          </button>
        </div>
        <img
          src="/assets/virtual-clinic.png"
          alt="Travel Clinic"
          className="section-image"
        />
      </div>
    </div>
  );
};

export default VaccinationSection;
